/* eslint-disable no-unused-vars */
import React from "react";
import { Button, Card } from "../../../../components";
import dockedControlsModule from "./DockedControls.module.scss";
import FormStep from "../../../../types/FormStep";
import { getTotalAmountForLineItemArray, getTotalVatAmountForLineItemArray } from "../../../../utils/Calculation";
import { numberWithSpaces } from "../../../../utils/utils";

export interface DockControlProps {
  data: any;
  step: FormStep;
  next: any;
  back: any;
  showLineItemTotals: boolean;
  canProceed: boolean;
}

const DockedControls: React.FC<DockControlProps> = ({ data, step, next, back, showLineItemTotals, canProceed }) => {
  const { lineItems } = data;
  return (
    <Card className={dockedControlsModule.DockCard}>
      {showLineItemTotals && (
        <div className={`${dockedControlsModule.PriceContainer} text-size-18`} style={{ color: "#3f3e38" }}>
          <div className="mb-2">
            <span>VAT total&nbsp;</span>
            <span className="text-bold">
              R&nbsp;
              {numberWithSpaces(getTotalVatAmountForLineItemArray(lineItems).toFixed(2))}
            </span>
          </div>
          <div className="mb-2">
            <span>Grand total&nbsp;</span>
            <span className="text-bold">
              R&nbsp;
              {numberWithSpaces(getTotalAmountForLineItemArray(lineItems).toFixed(2))}
            </span>
          </div>
        </div>
      )}
      <div className={dockedControlsModule.ButtonContainer}>
        {step.previousButtonText && (
          <Button
            type="button"
            className={`text-medium text-size-18 ${dockedControlsModule.DockedCardButton} ${dockedControlsModule.DockedCardButtonLeft}`}
            size="small"
            label={step.previousButtonText}
            varient="secondary"
            onClick={() => back()}
          />
        )}
        {step.nextButtonText && (
          <Button
            type="button"
            className={`text-medium text-size-18 ${dockedControlsModule.DockedCardButton} ${dockedControlsModule.DockedCardButtonRight}`}
            size="small"
            label={step.nextButtonText}
            varient="primary"
            disabled={!canProceed}
            onClick={() => next()}
          />
        )}
      </div>
    </Card>
  );
};

export default DockedControls;
